export function scrollToElement(element, yOffset = - 80) {
    if (!element) {
        return;
    }

    const yCoord = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: yCoord, behavior: 'smooth'});
}

export function toggle(element, className = 'collapsed') {
    if (!element) {
        return;
    }

    element.classList.contains(className) ? element.classList.remove(className) : element.classList.add(className);
}

export function switchActive(element) {
    if (!element || element.classList.contains('active')) {
        return;
    }

    const activeElement = element.parentNode.querySelector('.active');
    if (activeElement) {
        activeElement.classList.remove('active');
    }

    element.classList.add('active');
}

export function hide(element) {
    if (!element) {
        return;
    }

    element.classList.add('hidden');
}

export function show(element) {
    if (!element) {
        return;
    }

    element.classList.remove('hidden');
}